module.exports = __webpack_public_path__ + "img/clinique_header.eee1ca78.png";